import { Button, Form, message, Input, Col, Row, Modal } from 'antd';
import AppHeader from 'components/AppHeader';
import React, { useState, useEffect } from 'react';
import creditApis from 'api/creditApis';
import { ContentRow } from 'components/ThemeComponents';
import { StyledTable, OFFSET_HEADER } from 'components/ThemeComponents';
import { fullDateTimeFormat, onlyDateFormat } from 'helpers/dateTimeHelper';

export default function ListCreditsPage() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [credits, setCredits] = useState([]);
  const [isFetching, setIsFetching] = useState(false);
  const [paginate, setPaginate] = useState({})
  const [searchForm] = Form.useForm();

  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    // Add your submit logic here
  };

  async function fetchCredits(params={}) {
    setIsFetching(true);
    try {
      const res = await creditApis.listing(params);
      if (res.code === 200) {
        setCredits(res.data ?? []);
        setPaginate({page: res.page, limit: res.limit, total: res.total})
      }
    } catch (error) {
      message.info(error.message);
    }
    setIsFetching(false);
  }

  useEffect(() => {
    fetchCredits()
  }, []);

  const handleReactive = async (record) => {
    try {
      const res = await creditApis.reactive(record.id);
      
      if (res.code === 200) {
        message.success('Credit reactivated successfully');
        await fetchCredits();
      } else {
        message.error(res.message || 'Failed to reactive credit');
      }
    } catch (error) {
      message.error(error.message || 'An error occurred');
    }
  };

  const onChangeTable = async(pagination, filters, sorter) => {
    var params = {
      page: pagination.current,
      limit: pagination.pageSize,
      data_sort: sorter.columnKey,
      order_sort: sorter.order
    }
    const args = Object.assign({}, params, searchForm.getFieldsValue())
    await fetchCredits(args)
  }

  const onFinishSearchForm = async (values) => {
    const params = values || {}
    await fetchCredits(params)
  };

  const bottom = 'bottomRight';

  const columns = [
    {
      title: 'ID',
      width: '15rem',
      render: (record) => <span>{record.id}</span>
    },
    {
      title: 'tenant_id',
      width: '15rem',
      render: (record) => <span>{record.tenant_id}</span>
    },
    {
      title: 'order_payment_id',
      width: '10rem',
      render: (record) => <span>{record.order_payment_id}</span>
    },
    {
      title: 'status',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => (
        <span style={{ color: record.status === 'active' ? '#52c41a' : '#ff4d4f' }}>
          {record.status}
        </span>
      )
    },
    {
      title: 'type',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.type}</span>
    },
    {
      title: 'quota_limit',
      width: '10rem',
      render: (record) => <span>{record.quota_limit}</span>
    },
    {
      title: 'quota_used',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{record.quota_used}</span>
    },
    {
      title: 'start_date',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{onlyDateFormat(record.start_date)}</span>
    },
    {
      title: 'end_date',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{onlyDateFormat(record.end_date)}</span>
    },
    {
      title: 'created_at',
      width: '10rem',
      key: 'created_at',
      sorter: true,
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{fullDateTimeFormat(record.created_at)}</span>
    },
    {
      title: 'updated_at',
      width: '10rem',
      ellipsis: {
        showTitle: false
      },
      render: (record) => <span>{fullDateTimeFormat(record.updated_at)}</span>
    }
  ];
  
  return (
    <>
      <AppHeader
        fixedTop
        pageTitle="Tất cả credits"
        pageHeaderExtras={
          <>
            {/* <Button type="primary" onClick={showModal}>
              Thêm
            </Button> */}
          </>
        }
      />
      <Modal
        title="Add New Credit"
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <Form layout="vertical">
          <Form.Item
            name="tenant_id"
            label="Tenant ID"
            rules={[{ required: true, message: 'Please input tenant ID!' }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="quota_limit"
            label="Quota Limit"
            rules={[{ required: true, message: 'Please input quota limit!' }]}
          >
            <Input type="number" />
          </Form.Item>
          <Form.Item
            name="start_date"
            label="Start Date"
            rules={[{ required: true, message: 'Please select start date!' }]}
          >
            <Input type="date" />
          </Form.Item>
          <Form.Item
            name="end_date"
            label="End Date"
            rules={[{ required: true, message: 'Please select end date!' }]}
          >
            <Input type="date" />
          </Form.Item>
        </Form>
      </Modal>
      <br />
      <ContentRow capped>
        <Form
          form={searchForm}
          name="advanced_search"
          className="ant-advanced-search-form"
          onFinish={onFinishSearchForm}
          style={{marginBottom: "40px"}}
        >
          <Row gutter={24}>
            <Col span={8}>
              <Form.Item
                name='tenant_id'
                label='tenant_id'
              >
                <Input placeholder="Tìm theo tenant_id" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item
                name='domain'
                label='domain'
              >
                <Input placeholder="Tìm theo domain" />
              </Form.Item>
            </Col>
            <Col
              style={{
                textAlign: 'right',
              }}
            >
              <Button type="primary" htmlType="submit">
                Search
              </Button>
              <Button
                style={{
                  margin: '0 8px',
                }}
                onClick={() => {
                  searchForm.resetFields();
                  onFinishSearchForm();
                }}
              >
                Clear
              </Button>
            </Col>
          </Row>
        </Form>
        <StyledTable
          sticky={{ offsetHeader: OFFSET_HEADER }}
          size="small"
          scroll={{ x: 1000 }}
          loading={isFetching}
          rowKey="id"
          columns={columns}
          dataSource={credits}
          onChange={onChangeTable}
          pagination={{
            defaultPageSize: paginate.limit,
            defaultCurrent: paginate.page,
            total: paginate.total,
            position: [bottom],
            showTotal: (total, range) => (
              <span style={{ left: 0, position: 'absolute' }}>
                Hiển thị {range[0]}-{range[1]} của {total} tin đã đăng
              </span>
            )
          }}
        />
      </ContentRow>
    </>
  );
}
